import React from 'react';
import { pathOr } from 'ramda';
import { FormattedMessage } from 'react-intl';
import BarGraph from '../../../components/Graphs/BarGraph';
import KPICardContainer from '../../../components/KPICardContainer';
import { AsyncBox } from '@fortress-technology-solutions/fortress-component-library/Molecules';
import messages from './messages';
import {
  Box,
  Stack,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { palette } from '@fortress-technology-solutions/fortress-component-library/design';

const VacantNotLeasedByFloorplan = ({ data, dataLoaded }: Object) => {
  const labels = data && Object.keys(data).sort();
  const readyData =
    labels &&
    labels.map((label) => {
      return pathOr(0, [label, 'ready'], data);
    });
  const notReadyData =
    labels &&
    labels.map((label) => {
      return pathOr(0, [label, 'notReady'], data);
    });
  const datasets = [
    {
      label: 'Ready',
      data: readyData,
    },
    {
      label: 'Not Ready',
      data: notReadyData,
    },
  ];
  const stackedData = {
    labels,
    datasets,
  };
  return (
    <KPICardContainer
      title={<FormattedMessage {...messages.vacantNotLeasedByFloorplan} />}
      legend={
        <Stack spacing={1} direction={'row'} alignItems={'center'}>
          <Box
            sx={{
              backgroundColor: palette.main.blue,
              height: 12,
              width: 12,
              borderRadius: '50%',
            }}
          />
          <Typography variant={'bodySmall'} paddingLeft={0.5}>
            <FormattedMessage {...messages.ready} />
          </Typography>
          <Box
            sx={{
              backgroundColor: palette.light.blue,
              height: 12,
              width: 12,
              borderRadius: '50%',
            }}
          />
          <Typography variant={'bodySmall'} paddingLeft={0.5}>
            <FormattedMessage {...messages.notReady} />
          </Typography>
        </Stack>
      }
    >
      <div className="row">
        <div className="col-xs-12 col-sm-12">
          <AsyncBox loading={!dataLoaded}>
            <BarGraph data={stackedData} horizontal stacked />
          </AsyncBox>
        </div>
      </div>
    </KPICardContainer>
  );
};

export default VacantNotLeasedByFloorplan;
